import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from "react-router-dom";
import ReactDOMServer from 'react-dom/server';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import classnames from 'classnames';
import {Map} from "immutable";
import {Icon, ProgressBar} from "@blueprintjs/core";
import Modal from "@atlaskit/modal-dialog/dist/esm/components/Modal";

// Components
import CostBreakdownDetail from "./CostBreakdownDetail";
import CostBreakdownFiles from './CostBreakdownFiles';
import DeleteDialog from '../../../components/dialogs/DeleteDialog';
import CostBreakdownPrint from "../../../components/common/CostBreakdownPrint";

// Actions
import {
    getCostBreakdown,
    updateCostBreakdown,
    uploadCostBreakdownFiles,
    downloadCostBreakdownFile,
    deleteCostBreakdownFile,
    deleteCostBreakdown,
    cleanCostBreakdowns
} from "../../../actions/cost-breakdowns";
import {addNotification} from "../../../actions/notifications";
import {downloadPdf} from "../../../actions/content";

class CostBreakdownTabs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tabIndex: this.getSelectedIndex(),
            editMode: false,
            canSubmit: false,
            status: '',
            // modal
            modalIsOpen: false,
            modalType: null
        };

        this.getSelectedIndex = this.getSelectedIndex.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
    }
    componentDidMount() {
        this.props.getCostBreakdown(this.props.match.params.costBreakdownId);
    }
    componentWillUnmount() {
        this.props.cleanCostBreakdowns();
    }

    // Tab handlers
    getSelectedIndex() {
        const {costBreakdownId} = this.props.match.params;

        // Check if any child route is active. As last step, check if principal route is active to assign default tab index.
        switch (this.props.history.location.pathname) {
            case '/ventas/escandallos/' + costBreakdownId + '/detalle':
                return 0;
            case '/ventas/escandallos/' + costBreakdownId + '/ficheros':
                return 1;
            default:
                return 0;
        }
    }
    handleTabChange(index, lastIndex, event) {
        const {costBreakdownId} = this.props.match.params;
        let route = '';

        switch (index) {
            case 0:
                route = '/ventas/escandallos/' + costBreakdownId + '/detalle';
                break;
            case 1:
                route = '/ventas/escandallos/' + costBreakdownId + '/ficheros';
                break;
            default:
                break;
        }

        this.props.history.push(route);
        this.setState({
            tabIndex: this.getSelectedIndex()
        });
    }

    // CostBreakdownDetail handlers
    handleEditClick = () => {
        this.setState({
            editMode: true
        });
    };
    handleCancelClick = () => {
        this.child.updateCostBreakdownState();
        this.setState({
            editMode: false,
            canSubmit: false
        });
    };
    handleSaveClick = () => {
        this.child.updateCostBreakdown();
        this.setState({
            editMode: false
        });
    };
    canSubmit = (canSubmit) => {
        this.setState({ canSubmit })
    };

    // Print PDF
    printPdf = () => {
        const htmlHeader = ReactDOMServer.renderToStaticMarkup(<div></div>);
        const generateStaticMarkup = ReactDOMServer.renderToStaticMarkup(
            <CostBreakdownPrint
                costBreakdown={this.props.costBreakdown}
            />
        );
        const htmlFooter = ReactDOMServer.renderToStaticMarkup(
            <div style={{
                display: 'flex',
                fontSize: 10,
                textAlign: 'center',
                marginLeft: 50
            }} >INSCRITA EN EL REGISTRO MERCANTIL DE MURCIA, TOMO MU-3142, FOLIO 112, HOJA MU-87833</div>
        );

        this.props.downloadPdf(generateStaticMarkup, {
            title: this.props.costBreakdown.get('breakdown_code') + '.pdf',
            printBackground: true,
            displayHeaderFooter: true,
            headerTemplate: htmlHeader,
            footerTemplate: htmlFooter,
            margin: {
                top: '50px',
                right: '50px',
                left: '50px',
                bottom: '150px'
            }
        });
    };

    // Modal handlers
    openModal = (modalType) => {
        this.setState({
            modalType,
            modalIsOpen: true
        });
    };
    closeModal = () => {
        this.setState({
            modalType: null,
            modalIsOpen: false
        })
    };

    render() {
        const { tabIndex, editMode, canSubmit } = this.state;

        // Modal Area
        let modal = null;
        if (this.state.modalIsOpen) {
            switch (this.state.modalType) {
                case 'deleteDialog':
                    modal = {
                        width: 'medium',
                        title: 'Borrar escandallo de costes',
                        body: (
                            <DeleteDialog
                                text={ this.props.costBreakdown.get('breakdown_code') }
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="delete"
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={ () => {
                                        this.props.deleteCostBreakdown(this.props.costBreakdown.get('_id'));
                                        this.closeModal();
                                        this.props.history.push('/ventas/escandallos');
                                    }}
                                >
                                    {'Borrar'}
                                </button>
                            </div>
                        )
                    };
                    break;
                default:
                    modal = {
                        title: '',
                        body: null,
                        footer: null
                    };
                    break;
            }
        }

        return (

            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/ventas/resumen">Ventas</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/ventas/escandallos">Escandallos</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>{ `[${this.props.costBreakdown.get('breakdown_code')}] ${this.props.costBreakdown.get('name')}` }</strong>
                            </li>
                        </ol>
                    </div>
                    { this.props.uploadProgress.get('isUploading')
                        ? <div className="col d-flex align-items-center justify-content-end">
                            <ProgressBar
                                intent="PRIMARY"
                                value={ this.props.uploadProgress.get('percent') } />
                        </div>
                        : null
                    }
                    { tabIndex === 0
                        ? (
                            <div className="col d-flex align-items-center justify-content-end">
                                {!editMode
                                    ? <div className="title-action">
                                        <button
                                            className="btn btn-custom"
                                            onClick={ this.printPdf }
                                        ><Icon icon="print"/>Imprimir</button>
                                        { this.props.costBreakdown.get('can_delete')
                                                ? <button
                                                    className="btn btn-danger"
                                                    onClick={ () => this.openModal('deleteDialog') }
                                                >Borrar</button>
                                                : null
                                        }
                                        <button className="btn btn-custom" onClick={this.handleEditClick}>Editar</button>
                                    </div>
                                    : <div className="title-action">
                                        <button className="btn btn-cancel" onClick={this.handleCancelClick}>Cancelar</button>
                                        <button
                                            className="btn btn-primary"
                                            onClick={this.handleSaveClick}
                                            disabled={!canSubmit}
                                        >Guardar
                                        </button>
                                    </div>
                                }
                            </div>
                        ) : ''
                    }
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="tabs-container">
                                { this.props.costBreakdown.get('_id')
                                    ? (
                                <Tabs
                                    selectedIndex={tabIndex}
                                    onSelect={this.handleTabChange}
                                    selectedTabPanelClassName="active show"
                                >
                                    <TabList className="nav nav-tabs">
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 0})}>Detalle</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 1})}>Ficheros</Link>
                                        </Tab>
                                    </TabList>
                                    <div className="tab-content">
                                        <TabPanel className="tab-pane">
                                            <CostBreakdownDetail
                                                onRef={ref => (this.child = ref)}
                                                editMode={this.state.editMode}
                                                canSubmit={this.canSubmit}
                                                costBreakdown={this.props.costBreakdown}
                                                updateCostBreakdown={this.props.updateCostBreakdown}
                                            />
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            <CostBreakdownFiles
                                                costBreakdown={this.props.costBreakdown}
                                                uploadCostBreakdownFiles={this.props.uploadCostBreakdownFiles}
                                                uploadProgress={this.props.uploadProgress}
                                                downloadCostBreakdownFile={this.props.downloadCostBreakdownFile}
                                                deleteCostBreakdownFile={this.props.deleteCostBreakdownFile}
                                                addNotification={this.props.addNotification}
                                            />
                                        </TabPanel>
                                    </div>
                                </Tabs>
                                        )
                                        : null
                                    }
                            </div>
                        </div>
                    </div>
                </div>
                { this.state.modalIsOpen && (
                    <Modal
                        width={modal.width}
                        heading={modal.title}
                        footer={() => modal.footer}
                        autoFocus={false}
                        onClose={this.closeModal}
                    >
                        {modal.body}
                    </Modal>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    // Reducers
    const costBreakdownReducer = state.costBreakdowns;

    // CostBreakdown
    let costBreakdown = costBreakdownReducer.get('payload') || Map({});

    if (!(costBreakdown instanceof Map)) {
        costBreakdown = Map({})
    }

    // Upload Progress
    const uploadProgress = Map({
        isUploading: costBreakdownReducer.get('isUploading') || false,
        percent: costBreakdownReducer.get('percent') || 0
    });

    return {
        costBreakdown,
        uploadProgress
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCostBreakdown: (costBreakdownId) => dispatch(getCostBreakdown(costBreakdownId)),
        updateCostBreakdown: (costBreakdownId, costBreakdown) => dispatch(updateCostBreakdown(costBreakdownId, costBreakdown)),
        uploadCostBreakdownFiles: (costBreakdownId, files) => dispatch(uploadCostBreakdownFiles(costBreakdownId, files)),
        downloadCostBreakdownFile: (costBreakdownId, fileId) => dispatch(downloadCostBreakdownFile(costBreakdownId, fileId)),
        deleteCostBreakdownFile: (costBreakdownId, fileId) => dispatch(deleteCostBreakdownFile(costBreakdownId, fileId)),
        deleteCostBreakdown: (costBreakdownId) => dispatch(deleteCostBreakdown(costBreakdownId)),
        cleanCostBreakdowns: () => dispatch(cleanCostBreakdowns()),
        addNotification: (notification) => dispatch(addNotification(notification)),
        downloadPdf: (htmlString, pdfOptions) => dispatch(downloadPdf(htmlString, pdfOptions))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CostBreakdownTabs);



// WEBPACK FOOTER //
// ./src/containers/sales/cost-breakdowns/CostBreakdownTabs.js